import Base from "../../../Assets/javascripts/common/models/Base";

export default Base.extend({
    url: "/home/v1/GetMoreFlashSales",

    defaults: {
      html: null
    },

    initialize: function (options) {
      this.setFromAPI = this.setFromAPI.bind(this);

      this.nodeID = options.nodeID;
      this.html = null;
    },

    getEnvironment: function (options) {
      var page = options.page || 1
      return {
        update: {
          request: {
            type: "GetMoreFlashSales",
            value: options.nodeID + '|' + page
          }
        }
      };
    },

    setFromAPI: function (resp) {
      this.set('html', resp.data.content.flashsalesarticles.html)
    }
  });
